export default function orderByOrdering(a, b) {
  return (
    (a.ordering === null) - (b.ordering === null) ||
    +(a.ordering > b.ordering) ||
    -(a.ordering < b.ordering)
  );
}
